// extracted by mini-css-extract-plugin
export default {"attorneysSelect":"AttorneysSelects_attorneysSelect__NsQCI"};